import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import UserPage from './pages/UserPage';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import TripPage from './pages/TripsPage';
import DashboardAppPage from './pages/DashboardAppPage';
import RequireAuth from './hooks/require-auth';
import ScheduleTrip from './pages/ScheduleTrip';
import DetailsPage from './pages/DetailsPage';
import TripTrack from './pages/TripTrack';
import PaymentTrips from './pages/PaymentTrip';
import DetailsPaymentPage from './pages/DetailsPaymentPage';
import LinkTowPoint from './pages/LinkTowPoint';
import ShowTripPath from './pages/ShowTripPath';

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: '/dashboard',
      element: (
        <RequireAuth>
          <DashboardLayout />
        </RequireAuth>
      ),
      children: [
        { element: <Navigate to="/login" replace /> , index: true},
        { element: <Navigate to="/dashboard/app" /> },
        { path: 'app', element: <DashboardAppPage /> },
        { path: 'user', element: <UserPage /> },
        { path: 'trip', element: <TripPage /> },
        { path: 'schedule', element: <ScheduleTrip /> },
        { path: 'payment', element: <PaymentTrips/> },
        { path: 'details', element: <DetailsPage /> },
        { path: 'detailsp', element: <DetailsPaymentPage /> },
        { path: 'trip/track/:id', element: <TripTrack /> },
        // { path: 'linkTowPoint', element: <LinkTowPoint /> },
        { path: 'ShowTripPath', element: <ShowTripPath /> },
      ],
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      element: (
        <RequireAuth>
          <SimpleLayout />
        </RequireAuth>
      ),
      children: [
        // { element: <Navigate to="/dashboard/app" />, index: true },
        { element: <Navigate to="/login" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}